import { combineReducers } from 'redux';

import {
    StaticSitesDetailReducerState,
    staticSitesDetailReducer,
} from '../static-sites-detail/store/static-sites-detail-reducer';
import {
    StaticSitesListReducerState,
    staticSitesListReducer,
} from '../static-sites-list/store/static-sites-list-reducer';

export interface StaticSitesReducerState {
    staticSitesList: StaticSitesListReducerState;
    staticSitesDetail: StaticSitesDetailReducerState;
}

export const staticSitesReducer = combineReducers<StaticSitesReducerState>({
    staticSitesList: staticSitesListReducer,
    staticSitesDetail: staticSitesDetailReducer,
});
